import React, { Component } from 'react';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import NavbarSelector from '../NavbarSelector'
import ModalRoutes from './ModalRoutes';

import axios from "axios";
import { LoadingIcon } from '../Common/Loading_Icon';
import { Trans } from 'react-i18next';

class ContactUs extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading_contactus: false,
            vmh: null,
            province: "",
            email: "",
            link: "",
        };
    }

    componentDidMount() {
        document.title = "Contact Us - FleetXPress"
        var self = this;

        axios.get('/ajax/contactus/-1')
        .then(function(response) {
            self.setState({
                loading_contactus: true,
                vmh: response?.data.vmh,
                province: response?.data.province,
                email: response?.data.email,
                link: response?.data.link,
            })
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
    }

    render() {
        if(this.state.loading_contactus) {
            return (
                <div className = "bkg-white-dark pb-24">
                    {
                        this.props.userSession.logged_in && !this.props.userSession.user.pending_survey ?
                            <NavbarSelector history={this.props.history} match={this.props.match} location={this.props.location}/>
                        :
                            <span />
                    }
                    <div className = "l-1200-wrapper sh-list-wrapper">
                        <div className = "card">
                            <div className = "card-divider">
                                <span className = "card-header-title"><Trans>Contact Us</Trans></span>
                            </div>
                            <div className = 'card-section'>
                                <div className = 'row collapse'>
                                    <div id = 'contact-left' className = 'columns large-6 medium-12 small-12'>

                                        <h2 className = 'heading' style={{fontSize: '20px'}}>{this.state.vmh.Company}</h2>
                                        <div className = 'height-20'></div>
                                        <div className = 'contact-info'>
                                            <h4 className = 'type-label'><Trans>Address</Trans></h4>
                                            <p className = 'type-desc'>{this.state.vmh.Address_Company} {this.state.vmh.City_Company}, {this.state.province}</p>
                                            <p className = 'type-desc'>{this.state.vmh.Postal_Code}</p>
                                        </div>
                                        <div className = 'contact-info'>
                                            <h4 className = 'type-label'><Trans>Phone</Trans></h4>
                                            <p className = 'type-desc'>{this.state.vmh.Phone}</p>
                                        </div>
                                        <div className = 'contact-info'>
                                            <h4 className = 'type-label'><Trans>Email</Trans></h4>
                                            <p className = 'type-desc'><a href={"mailto:" + this.state.email} data-rel="external">{this.state.email}</a></p>
                                        </div>
                                    </div>
                                    <div id = 'contact-map' className = 'columns large-6 medium-12 small-12'>
                                        <iframe width='100%' height='400' frameborder='0' scrolling='no' marginheight='0' marginwidth='0' src={this.state.link}></iframe>
                                    </div>
                                </div>
                                <div id = 'clear'></div>
                            </div>
                        </div>
                    </div>
                    {
                        this.props.userSession.logged_in && !this.props.userSession.user.pending_survey ?
                            <ModalRoutes match={this.props.match} history={this.props.history}/>
                        :
                            <span />
                    }
                </div>
            );
        } else {
            return (
                <LoadingIcon />
            );
        }
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession
})

export default connect(mapStateToProps)(ContactUs)